import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter, useFilter } from "@/partner/shared/components/Filter";
import { DownloadReportButton } from "@/partner/features/reports";
import { ReportTypeType } from "@/types/graphql/partner.generated";
import { buildUsersFilter } from "../model/buildUsersFilter";

export const UsersFilter: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  return (
    <Filter
      title={t("users.filter.title")}
      action={
        <DownloadReportButton
          type={ReportTypeType.UsersType}
          filter={
            buildUsersFilter(filter) as Record<string, unknown> | undefined
          }
        />
      }
      fields={{
        search: true,
      }}
    />
  );
};
